import asyncCom from '@/CommonDP/commons/asyncCom';

export async function getFlowNodeHistory(props) {
  return await openflowNodeLog(props);
}

export const openflowNodeLog = async (props) => {
  const component = (await import('./flowInstanceNodeHistory.vue')).default;
  return await asyncCom(component, {}, props);
};
